import type { StorageMigration } from './types';

/**
 * Local-storage schema history.
 *
 * Version 1 is the initial `thrive.v1.*` layout, so its migration is a genuine no-op: there
 * is no earlier shipped format to convert. The scaffold exists now so the first real schema
 * change in a later phase cannot silently lose a child's progress.
 */
export const STORAGE_MIGRATIONS: readonly StorageMigration[] = [
  {
    from: 0,
    to: 1,
    description: 'v1 — initial thrive.v1.* layout (no data to convert)',
    migrate() {
      // Intentionally empty.
    },
  },
];

export const LATEST_STORAGE_SCHEMA_VERSION = STORAGE_MIGRATIONS.reduce(
  (latest, migration) => Math.max(latest, migration.to),
  0,
);

/**
 * Oldest envelope version this build can still make sense of.
 *
 * Version 1 is the first shipped layout, so today this equals the latest and nothing older
 * exists. It is a separate constant because the moment a v2 lands, v1 records must reach the
 * migration runner intact rather than being quarantined for the crime of being old.
 */
export const MINIMUM_SUPPORTED_STORAGE_SCHEMA_VERSION = STORAGE_MIGRATIONS.reduce(
  (earliest, migration) => Math.min(earliest, migration.to),
  LATEST_STORAGE_SCHEMA_VERSION,
);
